// extracted by mini-css-extract-plugin
export default {"root":"CategoryBreadcrumb_root__Xa4V5","item":"CategoryBreadcrumb_item__u3j4N","segmentButton":"CategoryBreadcrumb_segmentButton__3yVnb textBodySm"};